import { useEffect, useState } from 'react';

import { trpc, TrpcOutputs } from '../../config/trpc';
import { Quote, UseResource } from '../../utils/types';

type InstructionsOutput = TrpcOutputs['getInstructionsByQuoteId'];
type UseInstructions = UseResource<InstructionsOutput, never, never> & {
  hasNone?: boolean;
  isSetting?: boolean;
  handleSetInstructionsForQuote: (input: { quoteId: number; instructionId: number }) => Promise<Quote>;
};
export type Instruction = InstructionsOutput[0];

type UseInstructionsProps = {
  quoteId: number;
  providerId: string;
  airportId: string;
};

export const useInstructions = ({ quoteId, providerId, airportId }: UseInstructionsProps): UseInstructions => {
  const initQuery = trpc.getInstructionsByQuoteId.useQuery({ quoteId }, { refetchOnWindowFocus: false });
  const [data, setData] = useState<InstructionsOutput>();

  const { mutateAsync: handleSetInstructionsForQuote, isLoading: isSetting } = trpc.setInstructions.useMutation();

  useEffect(() => {
    if (initQuery.data) setData(initQuery.data);
  }, [initQuery.data]);

  trpc.onInstructionCreated.useSubscription(
    { provider_id: providerId, airport_id: airportId },
    {
      onData: (newData: Instruction) => {
        setData((prevData) => [...prevData, newData]);
      },
      onError: (err: any) => {
        console.log('onInstructionCreated error: ', err);
      },
    },
  );

  return {
    data,
    isLoading: initQuery?.isLoading,
    isSetting,
    hasNone: data?.length === 0,
    error: initQuery?.error?.message,
    handleSetInstructionsForQuote,
  };
};
